import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { InvoiceResponseValidationSchema } from './response';

export const RegenerateInvoicePathParamsValidationSchema = z.object({
  id: ObjectIdStringValidationSchema.meta({
    description: 'The ID of the invoice to regenerate.',
  }),
});

export const RegenerateInvoiceRequestBodyValidationSchema = z.object({}).strict().meta({
  description:
    'Empty body. The regeneration operation is parameter-less; the new PDF reflects current billing details on the source charge.',
});

export const RegenerateInvoiceResponseValidationSchema = z.object({
  data: InvoiceResponseValidationSchema,
});
